<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="cp-header">
      <div class="cp-label">
        {{ 'add_serial' | translate }}
      </div>
      <div class="cp-button" (click)="close()">
        <img src="assets/img/ic-close.png"/>
      </div>
    </div>

    <div class="content">

      <form [formGroup]="productForm">
        <div class="cp-field">
          <label class="cp-label">
            {{ 'product' | translate }}
          </label>
          <div class="cp-control" [class]="{'error': submitted && !productForm.get('trainerCode')?.valid}">
            <select class="cp-input" formControlName="trainerCode" id="trainerCode">
              @for (item of trainers(); track item.code) {
              <option [value]="item.code">{{ item.name }}</option>
              }
            </select>
            <button class="cp-control-button" style="pointer-events: none;">
              <img src="/assets/img/ic-arrow-down.png"/>
            </button>
          </div>
        </div>

        <div class="cp-field cp-p-top-20">
          <label class="cp-label">
            {{ 'serial' | translate }}
          </label>
          <div class="cp-control" [class]="{'error': submitted && !productForm.get('serial')?.valid}">
            <input class="cp-input" type="text" formControlName="serial">
          </div>
        </div>

        <div class="cp-field cp-p-top-20">
          <div class="cp-check-control">
            <div>
              <input type="checkbox" formControlName="check">
              @if (!productForm.get('check')?.value) {
              <img src="/assets/img/unchecked.png"> 
              }
              @else {
              <img src="/assets/img/checked.png"> 
              }
            </div>
            <div [class]="{'text-error': submitted && !productForm.get('check')?.valid}">
              {{ 'confirm_serial_text' | translate }}
            </div>  
          </div>
        </div>

        <div class="cp-field cp-p-top-20">
          @if (turnstileVisible()) {
          <ngx-turnstile [siteKey]="siteKey" theme="light" formControlName="token"></ngx-turnstile>
          }
        </div>
      </form>

    </div>

    <div class="cp-footer">
      <button class="coupon-button gray" (click)="close()">
        {{ 'cancel' | translate | uppercase }}
      </button>
      <button class="coupon-button" (click)="confirm()">
        {{ 'confirm_serial' | translate | uppercase }}
      </button>
    </div>

  </div>
</div>
